import React from "react";
import styled, {keyframes} from "styled-components";

interface ProgressDoneProps {
  width: string;
  color: string;
}

const progressAnimate = (width: string) => keyframes`
0% {
    opacity: 0;
    width: 0;
    
  }

  100% {
    opacity: 1;
    width: ${width}%;
  }
`;

const ProgressContainer = styled.article`
  display: flex;
  justify-content: center;
`;

const Progress = styled.article`
  background-color: #d8d8d8;
  border-radius: 20px;
  position: relative;
  margin: 4px 12px;
  height: 20px;
  width: 220px;
`;
const ProgressDone = styled.article<ProgressDoneProps>`
  background: ${(props) =>
    props.color === "primary"
      ? "linear-gradient(to left, #373b44, #4286f4)"
      : "linear-gradient(to left, #3c1053, #ad5389)"};
  box-shadow: ${(props) =>
    props.color === "primary"
      ? "0 3px 3px -5px #373b44, 0 2px 5px #4286f4"
      : "0 3px 3px -5px #3c1053, 0 2px 5px #ad5389"};
  border-radius: 20px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  animation: ${(props) => progressAnimate(props.width)} 2s forwards ease;
`;
const ProgressCount = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  width: 80px;
  & span {
    padding-left: 10px;
    font-weight: 500;
  }
  & strong {
    font-weight: bold;
  }
`;

type ProgressBarProps = {
  count: number;
  total: number;
  totalPercentage: number;
  width?: number;
  color: string;
};

const ProgressBar = ({count, total, totalPercentage, color}: ProgressBarProps) => {
  const percentage = totalPercentage.toFixed(0).toString();
  return (
    <ProgressContainer>
      <Progress>
        <ProgressDone width={percentage} color={color} />
      </Progress>
      <ProgressCount>
        <span>
          {count}/{total}
        </span>
        <span>
          <strong>({percentage}%)</strong>
        </span>
      </ProgressCount>
    </ProgressContainer>
  );
};

export default ProgressBar;
